import * as uuid from 'uuid';

// Analytics Event Category
enum AnalyticsEventCategory {
  CreditCardKYCSubmitApplicationDismissed = 'Credit_Card_KYC_Submit_Application_Dismissed',
  CreditCardKYCSubmitApplicationSuccess = 'Credit_Card_KYC_Submit_Application_Success',
  CreditCardKYCUserValidated = 'Credit_Card_KYC_User_Validated',
}

enum OwnerField {
  FirstName = 'FirstName',
  LastName = 'LastName',
  DateOfBirth = 'DateOfBirth',
  Country = 'Country',
  HouseNumberOrName = 'HouseNumberOrName',
  Street = 'Street',
  PostalCode = 'PostalCode',
  State = 'State',
  SsnEndingNumber = 'SsnEndingNumber',
  City = 'City',
  JobTitle = 'JobTitle',
}

enum Country {
  CA = 'CA',
  US = 'US',
}

enum KycSubmissionStatus {
  Completed = 'Completed',
  Incomplete = 'Incomplete',
  Loading = 'Loading',
  Processing = 'Processing',
}

enum LegalEntityType {
  BusinessCorporation = 'BusinessCorporation',
  CondominiumCorporation = 'CondominiumCorporation',
  LimitedLiabilityCorporation = 'LimitedLiabilityCorporation',
  NonprofitOrCharity = 'NonprofitOrCharity',
  NonprofitOrCharityRegistered = 'NonprofitOrCharityRegistered',
  NonprofitOrCharityUnregistered = 'NonprofitOrCharityUnregistered',
  Partnership = 'Partnership',
  SoleProprietorship = 'SoleProprietorship',
}

interface LegalEntity {
  text: string;
  value: string;
}

const localConfig = {
  minOwnerAge: 18,
  nonBusinessLegalEntityType: [
    LegalEntityType.SoleProprietorship,
    LegalEntityType.NonprofitOrCharity,
    LegalEntityType.NonprofitOrCharityRegistered,
    LegalEntityType.NonprofitOrCharityUnregistered,
  ],
  jobTitles: [
    'Chief Executive Officer',
    'Chief Financial Officer',
    'Chief Operating Officer',
    'Chief Information Officer',
    'Chief Strategy Officer',
    'President',
    'Vice President',
    'Executive President',
    'Managing Member',
    'General Partner',
    'Managing Partner',
    'Partner',
    'Treasurer',
    'Director',
  ],
};

function getLegalEntityTypeConstantValue(entityType: string): LegalEntityType {
  switch (entityType) {
    case 'Business Corporation':
      return LegalEntityType.BusinessCorporation;
    case 'Condominium Corporation':
      return LegalEntityType.CondominiumCorporation;
    case 'Partnership (GP, LP, LLP)':
      return LegalEntityType.Partnership;
    case 'Sole Proprietorship':
      return LegalEntityType.SoleProprietorship;
    case 'Limited Liability Corporation(LLC)':
      return LegalEntityType.LimitedLiabilityCorporation;
    case 'Nonprofit or Charity (Registered)':
      return LegalEntityType.NonprofitOrCharityRegistered;
    case 'Nonprofit or Charity (Unregistered)':
      return LegalEntityType.NonprofitOrCharityUnregistered;
    case 'Nonprofit or Charity':
      return LegalEntityType.NonprofitOrCharity;
  }
  return undefined;
}

/*
  Using uuid.v4() to assign a unique Id to a Kyc Form for each session
*/
function getUniquieIdentifier(): string {
  return uuid?.v4();
}

enum CompletionStagesBackend {
  Approved = 'APPROVED',
  Reviewing = 'REVIEWING',
  Completed = 'COMPLETED',
  Rejected = 'REJECTED',
}

export {
  AnalyticsEventCategory,
  Country,
  getLegalEntityTypeConstantValue,
  KycSubmissionStatus,
  LegalEntity,
  LegalEntityType,
  localConfig,
  OwnerField,
  getUniquieIdentifier,
  CompletionStagesBackend,
};
